<template>
    <div v-if="!this.loading">
        <v-container>
            <v-form>
                <v-row>
                    <h2 class="pb-5">{{ this.parentObject.pageTitle }}
                        <span class="page_title_value">
                            {{ this.parentObject.pageTitleValue }}
                        </span>
                    </h2>
                </v-row>
                <v-container
                    id="scroll-target"
                    class="custom-form overflow-y-auto px-5"
                >
                    <v-row>
                        <v-col cols="4" sm="4" class="pb-n5 ">
                           <v-text-field
                                outlined
                                :label="this.$t('columns.effectivefrom')"
                                type="date"
                                ref="startdate"
                                :rules="[rules.required]"
                                v-model="formData.startdate"
                                @input="updateValue"
                                @change="updateValue"
                                dense
                            ></v-text-field>
                        </v-col>

                        <v-col cols="4" sm="4" class="pb-n5 ">
                            <v-text-field
                                outlined
                                :label="this.$t('columns.effectiveuntil')"
                                type="date"
                                ref="enddate"
                                :rules="[rules.required]"
                                v-model="formData.enddate"
                                @input="updateValue"
                                @change="updateValue"
                                dense
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row v-if="this.parentObject.isEdit && this.loading === false">
                        <app-table 
                            v-bind:parentObject = "{
                                tabHeader: this.tabHeader,
                                detailItem: this.statutoryDetail,
                                formDataId: this.formDataId,
                            }"
                            v-on:input="addItemHandler"
                            v-on:error="forwardErrorHandler"
                            v-on:reload="loadDetail"
                            :key="statdetailkey"
                        />
                    </v-row>
                </v-container>

                <app-formbuttons 
                    v-bind:EditBool = this.parentObject.isEdit

                    v-on:NewPressed="newHandler"
                    v-on:SavePressed="saveHandler" 
                    v-on:DeletePressed="deleteHandler"
                    v-on:CancelPressed="cancelHandler" 
                />
            </v-form>
        </v-container>
    </div>
</template>

<script>
import CRUDTable from './CRUDTableNew';

export default {
    props: {
        parentObject: Object,
        value: {
            type: String,
            default: new Date().toISOString().substr(0, 10)
        }
    },

    components: {
        'app-table': CRUDTable
    },

    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
            },
            formDataId: this.parentObject.formDataId,
            formData: {
                id: this.parentObject.data.id,
                startdate: this.parentObject.data.startdate,
                enddate: this.parentObject.data.enddate,
                stamp: this.parentObject.data.stamp,
                userid: this.parentObject.data.userid
            },
            statutoryDetail: [],//empty array to hold the detail records
            loading: false,
            
            //app-table headers 
            tabHeader: [
                { text: this.$t('columns.actions'), value: 'action', width: '100px', sortable: false},
                { text: this.$t('setuppayitem.payitem'), value: 'payitemcode', width: '150px', sortable: true},
                { text: this.$t('setupbaitulmal.ea'), value:  'eafield_id', width: '80px', sortable: true},
                { text: this.$t('setupbaitulmal.tp1'), value: 'tp1field_id', width: '80px', sortable: true},
                { text: this.$t('setupbaitulmal.cp21'), value: 'cp21field_id', width: '90px', sortable: true},
                { text: this.$t('setupbaitulmal.cp22'), value: 'cp22field_id', width: '90px', sortable: true},
                { text: this.$t('setupbaitulmal.cp22a'), value: 'cp22afield_id', width: '90px', sortable: true},
                { text: this.$t('setupbaitulmal.cp22b'), value: 'cp22bfield_id', width: '90px', sortable: true},
                //{ text: this.$t('setupbaitulmal.payslip'), value: 'payslip', width: '100px', sortable: true},
                // This is now comment out, because payslip it not using yet
                // Have not decide how to implement it yet
                { text: this.$t('setupclaim.payitemdescription'), value: 'payitemdesc', width: '200px', sortable: true},
                { text: this.$t('setupbaitulmal.payitemtypedesc'), value: 'payitemtypedesc', width: '250px', sortable: true},
            ],

            errMsg: '',
            isErr: false,
            isEdit: this.parentObject.isEdit,

            statdetailkey: 0, //to force reload the table
        }
    },

    methods: {
        forwardErrorHandler(payload) {
            // this.errMsg = payload.errMsg;
            // this.isErr = payload.isErr;
            //this.$emit('error',this.isErr,this.errMsg);

            this.$emit('error',payload);//just redirect the entire payload to upward
        },

        addItemHandler() {
            this.loadDetail();  //here should reload the entire detail array
            this.updateValue();
        },  

        async loadDetail() {
            const vm = this;

            this.$store.dispatch('get', {url: "/statutoryreportsetupd/" + this.formData.id})
            .then((res) => {
                vm.statutoryDetail = res.data.rec;
                this.statdetailkey++; //force reload the table
            })
            .catch((err) => {
                vm.isErr = !vm.isErr;
                vm.errMsg = err;
            });
        },

        updateValue() {
            this.$emit('input', {
                id: this.formData.id,
                startdate: this.formData.startdate,
                enddate: this.formData.enddate,
                stamp: this.formData.stamp,
                userid: this.formData.userid
            });
        },


        newHandler() {
            this.$emit('new');
        },

        saveHandler() {
            this.updateValue();
            this.$emit('save');
        },

        deleteHandler() {
            this.$emit('delete');
        },

        cancelHandler() {
            this.$router.push({name: 'statutoryreportsetuplist'});
        },
    },

    async mounted() {
        this.loading = true;
        if(this.formData.id !== null && this.formData.id !== 0 && this.isEdit)
        {
            await this.loadDetail(); //if this is edit mode, load the detail records
        }
        
        this.loading = false;
    }
}
</script>